export default __webpack_public_path__ + "static/media/Oil2Gas_06.60302ec0.png";